import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Task } from '@ml/tasks/types/classes';
import { TaskLocationService } from '@ml/tasks/services/task-location.service';
import { Subject } from 'rxjs';
import { OrderLocationsService } from '@ml/orders/services';
import { takeUntil, tap } from 'rxjs/operators';
import { TaskLocation } from '@ml/tasks/types/classes/task-location.class';
import * as _ from 'lodash';
import { UserService } from '@ml/core/services';
var TaskLocationsDialogComponent = /** @class */ (function () {
    function TaskLocationsDialogComponent(data, userService, dialogRef, taskLocationService, orderLocationsService) {
        this.data = data;
        this.userService = userService;
        this.dialogRef = dialogRef;
        this.taskLocationService = taskLocationService;
        this.orderLocationsService = orderLocationsService;
        this.ngUnsubscribe = new Subject();
    }
    TaskLocationsDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.task = _.cloneDeep(this.data);
        if (this.userService.isEmployee) {
            this.disableSelect = true;
        }
        var orderId = this.task.order.id;
        this.taskLocationService.taskId = this.task.id;
        this.loading = true;
        this.taskLocationService
            .list()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (values) {
            _this.taskLocations = values;
            _this.selectedLocations = _this.taskLocations.map(function (value) {
                return value.orderLocation.location.id;
            });
        });
        this.orderLocationsService
            .subscribe$(orderId)
            .pipe(takeUntil(this.ngUnsubscribe), tap(function () { return (_this.loading = false); }))
            .subscribe(function (values) {
            _this.orderLocations = values;
            _this.locations = _this.orderLocations.map(function (value) {
                var locationWithStatus = value.location;
                locationWithStatus.status = value.status;
                return locationWithStatus;
            });
        });
    };
    TaskLocationsDialogComponent.prototype.onAddLocations = function (locations) {
        var _this = this;
        var taskLocations = locations.map(function (location) {
            var orderLocationId = _this.orderLocations.find(function (value) { return value.location.id === location; }).id;
            var taskLocation = new TaskLocation();
            taskLocation.task = _this.task.id;
            taskLocation.orderLocation = orderLocationId;
            return taskLocation;
        });
        this.taskLocationService.bulkCreate(taskLocations).subscribe(function (values) {
            var _a;
            var newLocations = values.map(function (value) { return (tslib_1.__assign({}, value, { orderLocation: _this.orderLocations.find(function (item) { return item.id === value.orderLocation; }) })); });
            (_a = _this.taskLocations).push.apply(_a, newLocations);
        });
    };
    TaskLocationsDialogComponent.prototype.onRemoveLocations = function (locations) {
        var _this = this;
        var taskLocations = this.taskLocations
            .filter(function (value) {
            return locations.indexOf(value.orderLocation.location.id) >= 0;
        })
            .map(function (value) { return value.id; });
        this.taskLocationService
            .bulkRemove(taskLocations)
            .subscribe(function () {
            return (_this.taskLocations = _this.taskLocations.filter(function (value) { return taskLocations.indexOf(value.id) <= 0; }));
        });
    };
    TaskLocationsDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    TaskLocationsDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return TaskLocationsDialogComponent;
}());
export { TaskLocationsDialogComponent };
